import { render, staticRenderFns } from "./CardGoal.vue?vue&type=template&id=7465c7ac&"
import script from "./CardGoal.vue?vue&type=script&lang=js&"
export * from "./CardGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports